import Joi from 'joi';
import { rules } from '../../helpers/forms';

const genErr = (type, errorMessages) => {
  if (type.includes(rules.required)) {
    return errorMessages.required;
  }
  return errorMessages[type] || errorMessages.format;
};

export default (val, name, schema, errorMessages) => {
  if (!schema) return null;

  const joiSchema = Joi.isSchema(schema) ? schema : Joi.object(schema);
  const valRes = joiSchema.validate({
    [name]: val,
  }, { abortEarly: false });

  if (!valRes.error) return null;

  const errors = valRes.error.details.reduce((all, cur) => {
    const allErrors = { ...all };
    const path = cur.path[cur.path.length - 1];

    if (Object.prototype.hasOwnProperty.call(allErrors, path)) {
      allErrors[path] += ` ${genErr(cur.type, errorMessages[name])}`;
    } else {
      allErrors[path] = genErr(cur.type, errorMessages[name]);
    }
    return allErrors;
  }, {});

  return errors[name];
};
